// Angular Core
import { Validators } from "@angular/forms";

// Interfaces
import { FormControlStructure } from "../../interfaces/FormControlStructure";

export const formControls: FormControlStructure[] = [
  {
    controlName: 'password',
    validators: [Validators.required],
    validatorsMessages: [
      {
        validatorName: 'required',
        errorMessage: 'Senha é obrigatória'
      },
      {
        validatorName: 'fieldsMismatch',
        errorMessage: 'As senhas não são iguais'
      }
    ],
    initialValue: ''
  },
  {
    controlName: 'confirm_password',
    validators: [Validators.required],
    validatorsMessages: [
      {
        validatorName: 'required',
        errorMessage: 'Confirmação de senha é obrigatória'
      },
      {
        validatorName: 'fieldsMismatch',
        errorMessage: 'As senhas não são iguais'
      }
    ],
    initialValue: ''
  }
]
